import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const CustomButtonWithIcon = (props) => {
    const {
        onClick,
        icon,
        text,
        className,
        ...rest
    } = props;

    return (
		<>
           <button
                type="button"
                className={"btn btn-primary btn-search " + className}
                onClick={onClick}
                {...rest}
            >
                {icon && (
                    <>
                        {icon}
                    </>
                )}

                {text && (
                    <>
                        {text}
                    </>
                )}
            </button>
        </>
    );
};

CustomButtonWithIcon.propTypes = {
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
    ]),
    text: PropTypes.string,
    className: PropTypes.string,
};

export default CustomButtonWithIcon;